module.exports = __webpack_public_path__ + "static/img/4.acde63a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/4.png
// module id = iQte
// module chunks = 0